import { colors } from '@theme/colors';

import { TypographyOptions } from '@mui/material/styles/createTypography';
import { SystemMode } from '@mui/system/cssVars/useCurrentColorScheme';

import { THEME_HEADER_HEIGHT } from '@config/theme';

const LETTER_SPACING = '0.00968em';
const BUTTON_LETTER_SPACING = '0.02857em';

export const themeTypography = (
  mode: SystemMode = 'light'
): TypographyOptions => ({
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  h6: {
    fontWeight: 500,
    color: colors.grey900,
    fontSize: '0.75rem',
    letterSpacing: LETTER_SPACING,
  },
  h5: {
    fontSize: '0.875rem',
    color: colors.grey900,
    fontWeight: 500,
    letterSpacing: 0,
  },
  h4: {
    fontSize: '1rem',
    color: colors.grey900,
    fontWeight: 600,
  },
  h3: {
    fontSize: '1.25rem',
    color: colors.grey900,
    fontWeight: 600,
  },
  h2: {
    fontSize: '1.5rem',
    color: colors.grey900,
    fontWeight: 700,
  },
  h1: {
    fontSize: '2.125rem',
    color: colors.grey900,
    fontWeight: 700,
  },
  subtitle1: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: mode === 'dark' ? colors.grey900! : colors.grey900,
  },
  subtitle2: {
    fontSize: '0.75rem',
    fontWeight: 400,
    color: colors.grey500,
  },
  caption: {
    fontSize: '0.75rem',
    color: colors.grey500,
    fontWeight: 400,
  },
  body1: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: '1.334em',
  },
  body2: {
    letterSpacing: '0em',
    fontWeight: 400,
    lineHeight: '1.5em',
    color: colors.grey700,
  },
  button: {
    letterSpacing: BUTTON_LETTER_SPACING,
    textTransform: 'capitalize',
  },
  customInput: {
    marginTop: 1,
    marginBottom: 1,
    '& > label': {
      top: 23,
      left: 0,
      color: colors.grey500,
      '&[data-shrink="false"]': {
        top: 5,
      },
    },
    '& > div > input': {
      padding: '30.5px 14px 11.5px !important',
    },
    '& legend': {
      display: 'none',
    },
    '& fieldset': {
      top: 0,
    },
  },
  mainContent: {
    letterSpacing: LETTER_SPACING,
    backgroundColor: colors.primaryLight,
    width: '100%',
    minHeight: `calc(100vh - ${THEME_HEADER_HEIGHT}px)`,
    flexGrow: 1,
    padding: '20px',
    marginTop: `${THEME_HEADER_HEIGHT}px`,
    marginRight: '20px',
  },
  menuCaption: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: colors.grey900,
    padding: '6px',
    textTransform: 'capitalize',
    marginTop: '10px',
  },
  subMenuCaption: {
    fontSize: '0.6875rem',
    fontWeight: 500,
    color: colors.grey500,
    textTransform: 'capitalize',
  },
  commonAvatar: {
    cursor: 'pointer',
    borderRadius: '8px',
  },
  smallAvatar: {
    width: '22px',
    height: '22px',
    fontSize: '1rem',
  },
  mediumAvatar: {
    width: '34px',
    height: '34px',
    fontSize: '1.2rem',
  },
  largeAvatar: {
    width: '44px',
    height: '44px',
    fontSize: '1.5rem',
  },
});
